import { render } from "./px-input-places.vue?vue&type=template&id=f6c9eff6&ts=true"
import script from "./px-input-places.vue?vue&type=script&lang=ts"
export * from "./px-input-places.vue?vue&type=script&lang=ts"

import "./px-input-places.vue?vue&type=style&index=0&id=f6c9eff6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__